// Shared mic/audio coordination between Radio, D.A.R. and Hey MR.
//
// D.A.R. and Hey MR hold a "claim" while they own the microphone or play a
// spoken reply. While any claim is held, the Radio transport stops talking
// (releases its mic) and ducks incoming Radio audio; it restores on release.
// This keeps exactly one owner of the microphone at a time.
type Listener = (busy: boolean) => void;

let claims = 0;
const listeners = new Set<Listener>();

function emit() {
  const busy = claims > 0;
  listeners.forEach((l) => {
    try {
      l(busy);
    } catch {
      /* ignore */
    }
  });
}

/** Claim the mic/audio focus. Returns an idempotent release function. */
export function claimVoiceFocus(): () => void {
  claims += 1;
  emit();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    claims = Math.max(0, claims - 1);
    emit();
  };
}

export function isVoiceFocusBusy(): boolean {
  return claims > 0;
}

export function onVoiceFocusChange(l: Listener): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

/** Remote Radio volume while D.A.R. records or Hey MR speaks. */
export const RADIO_DUCKED_VOLUME = 0.2;
